import React from 'react';
import { crawlerDuplicateAvoidStyle } from '../../utils/commonUtils';
import { getPageName } from '../../utils/getPageSectionName';
import { trackClickEventProp61 } from '../../utils/omnitureUtils';

type CompactListProps<T> = {
  title: string | null;
  list: T[];
  className?: string;
  children: (item: T, idx: number) => React.ReactNode;
  eventName: string;
};

export default function CompactList<T>({ title, list, className = '', children, eventName }: CompactListProps<T>) {
  return (
    <div className={`railSeoWrap__stnDetailsBlock ${className}`}>
      <h3 className="railSeoWrap__stnDetails--title desktopShow font22 latoBold appendBottom15">{title}</h3>
      <div className="railSeoWrap__aboutStn">
        <h3
          style={crawlerDuplicateAvoidStyle}
          className="railSeoWrap__stnDetails--title mobileShow font22 appendBottom10 latoLight"
        >
          {title}
        </h3>
        <ul
          className="railSeoWrap__rwStnList"
          onClick={() => {
            if (eventName?.length) trackClickEventProp61(getPageName(eventName), eventName);
          }}
        >
          {list && list.map((item, idx) => children && children(item, idx))}
        </ul>
      </div>
    </div>
  );
}
